<template>
    <div class="loginbackground" v-bind:style="{ backgroundImage: 'url(' + backgroundImageUrl + ')' }">
    </div>
</template>
<script>
export default {
  data () {
    return {
      backgroundImageUrl: require(`@/assets/img/${process.env.VUE_APP_NODE_ENV_API}/background-login.svg`)
    }
  }
}
</script>
